export default {
  registerCode: (state) => {
    return state.registerCode;
  },

  token: (state) => {
    return state.token;
  },

  forgotCheck: (state) => {
    return state.forgotCheck;
  },

  checkNewRegister: (state) => {
    return state.checkNewRegister;
  },

  forgotCode: (state) => {
    return state.forgotCode;
  },

  profile: (state) => {
    return state.profile;
  },
  factors: (state) => {
    return state.factors;
  },


  factorById: (state) => {
    return state.factorById;
  },

  paymentResult: (state) => {
    return state.paymentResult;
  },

  genderOptions() {
    return [
      { value: 1, text: "آقا" },
      { value: 2, text: "خانم" },
    ];

  },
  address: (state) => {
    return state.address;
  },

  factorDetail: (state) => {
    return state.factorDetail;
  },


  favorites: (state) => {
    return state.favorites;
  },
  favorite: (state) => {
    return state.favorite;
  },

  availableReturnProducts: (state) => {
    return state.availableReturnProducts;
  },
  // availableReturnProductsOptions: (state) => {
  //   const availableReturnProductsOptions = [];
  //   state.availableReturnProducts.forEach(func);
  //   function func(item) {
  //     const pushItem = {
  //       value: item.factorDetailId,
  //       text: item.title,
  //     };
  //     availableReturnProductsOptions.push(pushItem);
  //   }
  //   return availableReturnProductsOptions;
  // },
  returns: (state) => {
    return state.returns;
  },

  tickets: (state) => {
    return state.tickets;
  },
  ticket: (state) => {
    return state.ticket;
  },

  payBanks: (state) => {
    return state.payBanks;
  },

  festivalDiscount: (state) => {
    return state.festivalDiscount;
  },


};
